import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addEmployeeApi,
  blockMemberApi,
  deleteEmployeeApi,
  editEmployeeApi,
  GetTeamsApi,
  moderationApi,
  reinviteEmployeeApi,
  verifyEmployeeApi,
  resetEmployeePasswordApi,
  toggleAdminRoleApi,
  employeePaginatedApi,
} from "../apis/TeamsApi";
import { showSnackbar } from "../slices/SnackbarSlice";
import { routes } from "../../utils/routes";

export const fetchTeamMembers = createAsyncThunk(
  "teams/fetchTeamMembers",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await GetTeamsApi(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch team members");
    }
  }
);

export const employeePaginatedAction = createAsyncThunk("employee-paginated", async (payload: { business_id: string, page: number, limit: number, keyword: string, sort_by?: string, sort_order?: string }, { rejectWithValue, dispatch }) => {
  try {
    const response = await employeePaginatedApi(payload);
    return response.data;
  } catch (error: any) {
    dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
    return rejectWithValue(error?.message || "Failed to get employee paginated");
  }
})

export const addEmployeeAction = createAsyncThunk(
  "add/employee",
  async ({ payload, navigate }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await addEmployeeApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      if (typeof navigate === "function") {
        navigate(routes?.mapCheckingSetting, { state: 1 });
      }
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to add employee");
    }
  }
);
export const editEmployeeAction = createAsyncThunk(
  "edit/employee",
  async ({ payload, navigate }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await editEmployeeApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      navigate(routes?.mapCheckingSetting, { state: { tabIndex: 1 } });
      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to add employee");
    }
  }
);

export const verifyEmployeeAction = createAsyncThunk(
  "verify/employee",
  async ({ payload, navigate }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await verifyEmployeeApi(payload);

      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      navigate(routes?.download);

      return response.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to verify employee");
    }
  }
);
export const blockMemberAction = createAsyncThunk(
  "block/employee",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await blockMemberApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data.data;
      // 👆 will be { _id, email, first_name, last_name, status }
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.message,
          type: "error",
        })
      );
      return rejectWithValue(
        error?.message || "Failed to block/unblock employee"
      );
    }
  }
);

export const ModerationMemeberAction = createAsyncThunk(
  "moderation/employee",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await moderationApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to toggle moderation");
    }
  }
);

export const deleteEmployeeAction = createAsyncThunk(
  "delete/employee",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await deleteEmployeeApi(payload);
      dispatch(
        showSnackbar({ message: response?.data?.message, type: "success" })
      );
      return response.data.data;
    } catch (error: any) {
      dispatch(
        showSnackbar({ message: error?.response?.data?.message, type: "error" })
      );
      return rejectWithValue(error?.message || "Failed to delete employee");
    }
  }
);


export const reinviteEmployeeAction = createAsyncThunk("reinvite-employee", async (employee_id: string, { rejectWithValue, dispatch }) => {
  try {
    const response = await reinviteEmployeeApi(employee_id);
    dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
    return response.data;
  } catch (error: any) {
    dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
    return rejectWithValue(error?.message || "Failed to reinvite employee");
  }
});
export const resetEmployeePasswordAction = createAsyncThunk("reset-employee-password", async (payload: { employee_id: string, new_password: string }, { rejectWithValue, dispatch }) => {
  try {
    const response = await resetEmployeePasswordApi(payload);
    dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
    return response.data;
  } catch (error: any) {
    dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
    return rejectWithValue(error?.message || "Failed to reset password");
  }
});

export const toggleAdminRoleAction = createAsyncThunk("toggle-admin-role", async (payload: { employee_id: string, business_id: string }, { rejectWithValue, dispatch }) => {
  try {
    const response = await toggleAdminRoleApi(payload);
    // dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
    return response.data;
  } catch (error: any) {
    // dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
    return rejectWithValue(error?.message || "Failed to toggle admin role");
  }
});